import 'css-chunksrc/client/scenes/resourceDeactivation/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_1m6lj_1",
  "profession": "_profession_1m6lj_9",
  "avatar": "_avatar_1m6lj_15",
  "name": "_name_1m6lj_25",
  "email": "_email_1m6lj_31"
};